import { render } from "./profile.svg?vue&type=template&id=91ad3c70"
const script = {}
script.render = render

export default script